import React from 'react';

export const OVERLAY_POSITIONS = [
  'top-left', 'top-center', 'top-right',
  'middle-left', 'middle-center', 'middle-right',
  'bottom-left', 'bottom-center', 'bottom-right',
] as const;

/**
 * The 9-cell anchor grid on every element toolbar. One copy for the card and
 * the template editor (each used to carry its own).
 */
const MiniPositionPicker: React.FC<{
  currentPosition: string;
  onChange: (pos: string) => void;
  className?: string;
}> = ({ currentPosition, onChange, className = '' }) => (
  <div
    className={`grid grid-cols-3 gap-0.5 bg-black/40 p-0.5 rounded cursor-default ${className}`}
    title="Anchor"
  >
    {OVERLAY_POSITIONS.map((pos) => {
      const isActive = currentPosition === pos;
      return (
        <button
          key={pos}
          type="button"
          onMouseDown={(e) => e.preventDefault()}
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            onChange(pos);
          }}
          className={`w-1.5 h-1.5 rounded-[1px] transition-colors ${isActive
            ? 'bg-blue-400 shadow-[0_0_2px_rgba(96,165,250,0.8)]'
            : 'bg-white/30 hover:bg-white/60'}`}
          title={pos.replace('-', ' ')}
          aria-label={`Anchor ${pos.replace('-', ' ')}`}
          aria-pressed={isActive}
        />
      );
    })}
  </div>
);

export default MiniPositionPicker;
